module.exports = __webpack_public_path__ + "media/AIChatbotIndicator.36e3bb0b.webm";